import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors } from '@nw/shared/config';

import { SVGComponentProps } from '../type';

interface PaymentOptionRadioIconProps extends SVGComponentProps {
  selected: boolean;
}

/*
 * Payment option radio placeholder — replace SVG markup in this file when design asset is available.
 */
const PaymentOptionRadioIcon: FC<PaymentOptionRadioIconProps> = ({
  width = 20,
  height = 20,
  selected
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {selected ? (
        <>
          <circle cx="10" cy="10" r="10" fill={colors['light-red-800']} />
          <path
            d="m6 10.2 2.6 2.6L14 7.4"
            stroke={colors['base-white']}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <circle
          cx="10"
          cy="10"
          r="9.5"
          fill={colors['base-white']}
          stroke={colors['light-blue-gray-200']}
        />
      )}
    </svg>
  </SVGUniqueID>
);

export { PaymentOptionRadioIcon };
